import React from 'react';
import './ErrorPageMessage.css';

export function ErrorPageMessage() {
  return (
    <div className="error-message">
      <h2>Something went wrong.</h2>
    </div>
  );
}
